import { actionTypes } from './actions';

const initialState = {
  items: [],
  selectedIndex: 0,
  isLoading: false,
  isOpen: false,
  hasChecked: false,
};

const pronunciationCheckReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_NSW_ITEMS:
      return {
        ...state,
        items: action.payload.map((item) => ({ ...item, applied: false })),
        selectedIndex: 0,
        hasChecked: true,
      };

    case actionTypes.SELECT_NSW_ITEM:
      return { ...state, selectedIndex: action.payload };

    case actionTypes.SET_NSW_LOADING:
      return { ...state, isLoading: action.payload };

    case actionTypes.SET_NSW_SIDEBAR_OPEN:
      return { ...state, isOpen: action.payload };

    case actionTypes.MARK_NSW_APPLIED:
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload ? { ...item, applied: true } : item,
        ),
      };

    case actionTypes.MARK_ALL_NSW_APPLIED:
      return {
        ...state,
        items: state.items.map((item) =>
          item.word === action.payload?.word
            ? {
                ...item,
                applied: true,
                pronunciation: action.payload?.pronunciation,
              }
            : item,
        ),
      };

    case actionTypes.UPDATE_PRONUNCIATION:
      return {
        ...state,
        items: state.items.map((item, i) =>
          i === action.payload.index
            ? { ...item, pronunciation: action.payload.pronunciation }
            : item,
        ),
      };

    case actionTypes.SYNC_NSW_ITEMS_WITH_ENTITIES: {
      const survivingIds = new Set(action.payload.map((sw) => sw.id));
      const filteredItems = state.items.filter((item) =>
        survivingIds.has(item.id),
      );

      if (filteredItems.length === state.items.length) return state;

      if (filteredItems.length === 0) return initialState;

      const newSelectedIndex = Math.max(
        0,
        filteredItems.findIndex((item) => !item.applied),
      );
      return {
        ...state,
        items: filteredItems,
        selectedIndex: newSelectedIndex,
      };
    }

    case actionTypes.RESET_NSW:
      return initialState;

    default:
      return state;
  }
};

export { initialState };
export default pronunciationCheckReducer;
